<template>
    <div class="approve-item-container" @click="handleGoDetail">
        <div class="approve-item__header flex flex-row">
            <div class="title ellipsis flex-0shrink">{{ title }}</div>
            <div class="time">{{ time }}</div>
        </div>

        <!-- rows example -->
        <!-- <li v-for="(row, idx) in rows" :key="idx">
            <div class="row__title">{{ row.label }}</div>
            <div class="row__content">{{ row.val }}</div>
        </li> -->
        <div class="approve-item__main">
            <render-dom :vnode="rowsRender" />
        </div>

        <!-- 
            [处理状态]
                1[待处理] 某人审批 + 处理中
                2[已处理] 通过与否
                3[我收到的] 不展示

            [审批状态]
                2[审批中]
                3[已通过]
                4[已驳回]
                5[已撤销]

        -->
        <!-- stateus-br -->

        <!-- v-if= tabval = 1,2,4 只有展示 status-bar -->
        <!-- v-if="[1, 2, 3, 4].includes(flagState)" -->
        <div class="approve-item__status-bar">
            <div v-if="showLRBox" class="wait flex flex-row flex-row-acc">
                <div class="personal">{{ waitPersonalComp }}</div>
                <div :class="[
                    'status',
                    statusOtherClass
                ]">{{ waitStatusComp }}</div>
            </div>
            <div v-else-if="showLbox" class="approved">
                <div :class="[
                    'status',
                    statusOtherClass
                ]">{{ approvedStatusComp }}</div>
            </div>
            <!-- v-else 没有状态展示 -->
        </div>
    </div>
</template>

<script>

// NOTE: 状态参考
// 申请人(info) - 状态: 2=审批中,3=审批通过,4=审批驳回,5=审批撤销 
// 审批人(approve) - 状态: 1=待审批,2=审批中,3=审批同意,4=审批驳回 

let h = null
export default {
    name: 'ApproveItem',
    computed: {
        showLRBox() { // 展示底部左右两侧信息
            let type = this.flag
            let key = Number(this.flagState)
            // console.log('showLRBox=========', type, key);
            return (type === 'approve' && [1, 2].includes(key)) || (type === 'info' && [2].includes(key))
        },
        // 根据状态渲染不同的样式
        statusOtherClass() {
            let key = Number(this.flagState)
            let className = ''
            switch (key) {
                case 3:
                    className = 'status--pass'
                    break
                case 4:
                    className = 'status--refuse'
                    break
                case 5:
                    className = 'status--refuse'
                    break
            }
            return className
        },
        showLbox() { // 只展示左侧线索
            let type = this.flag
            let key = Number(this.flagState)
            console.log('showLbox', type, key);
            return (type === 'approve' && [3, 4].includes(key)) || (type === 'info' && [3, 4, 5].includes(key))
        },

        rowsRender() {
            return h('ul', {
                class: ['flex', 'flex-col']
            }, this.rows.map(row => h('li', {
                class: ['row', 'flex', 'flex-row']
            }, [
                h('div', {
                    class: ['row__title', 'flex-0shrink']
                }, `${row.label}：`),
                h('div', {
                    class: ['row__content', 'ellipsis-2rows']
                }, row.val)
            ])))
        },

        // 根据 falg 和 flagState进行
        waitPersonalComp() {
            let type = this.flag
            let key = this.flagState
            let returnStr = ''
            let person = this.person

            if (!person) return ''
            if (type === 'approve' || (type === 'info' && key === 2)) {
                returnStr = `${person}处理中`
            } else if (type === 'info' && key === 4) {
                returnStr = `${person}已处理`
            }
            return returnStr
        },

        // 通过枚举文件确定状态
        waitStatusComp() {
            // let type = this.flag
            let key = Number(this.flagState)
            if (key === 4) return `已驳回`
            return `处理中`
        },

        approvedStatusComp() {
            // let type = this.flag
            let key = Number(this.flagState)
            let rStr = ''
            switch (key) {
                case 3:
                    rStr = '已通过'
                    break
                case 4:
                    rStr = '已驳回'
                    break
                case 5:
                    rStr = '已撤销'
                    break
            }
            return rStr
        }
    },
    props: {
        // Item类型。 根据类型渲染不同的main内容
        approveType: {
            type: String,
            required: true
        },
        // 标题：xxxx提交的申请/xxxx
        title: {
            type: String
        },
        // 标题右侧时间节点
        time: {
            type: String
        },

        // main内容数据列表 [{label, val}]
        rows: {
            type: Array,
            default: () => []
        },

        flag: { // 添加标识判断是 处理展示/申请展示
            validator: key => (['info', 'approve'].includes(key))
        },

        flagState: { // 进度标识： 处理/申请的类型(123,2345)
            validator: key => ([1, 2, 3, 4, 5].includes(key))
        },

        // 添加当前审核人
        person: {
            type: String
        }

    },
    created() {
        h = this.$createElement
    },
    methods: {
        // NOTE: 前往项目详情页
        handleGoDetail() {
            if (this.$listeners.click) this.$emit('click')
        }
    }
}
</script>

<style lang="less" scoped>
@import url("@/styles/variables.less");

.approve-item {
    &-container {
        padding: 20px 12px 12px;
        background-color: @white;
        border-radius: 4px;
    }

    &__header {
        justify-content: space-between;

        .title {
            flex: 1;
            font-size: @font-size-common;
            font-weight: 600;
            color: #191A1E;
            line-height: 24px;
            padding-right: 16px;
        }

        .time {
            font-size: 11px;
            font-weight: 400;
            color: #B0B0B0;
            line-height: 24px;
        }
    }

    // 内容盒子
    &__main {
        padding: 4px 0 6px;

        .row {
            align-items: flex-start;
            font-size: @font-size-third;
            font-weight: 400;
            color: #727273;
            line-height: 20px;

            &__content {
                flex: 1;
            }
        }
    }

    // 状态栏
    &__status-bar {
        .wait {
            justify-content: space-between;

            .personal {
                font-size: @font-size-third;
                font-weight: 400;
                color: #191A1E;
                line-height: 18px;
            }

            .status {
                font-size: @font-size-third;
                font-weight: 500;
                color: #DF9C4A;
                line-height: 18px;

                &--refuse {
                    color: #FF0000;
                }
            }
        }

        .approved {
            .status {
                font-size: @font-size-third;
                font-weight: 500;
                line-height: 18px;

                &--pass {
                    color: #57AF61;
                }

                &--refuse {
                    color: #FD5420;
                }
            }
        }

    }
}
</style>